/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
import { MapTo, Container } from '@adobe/aem-react-editable-components';
import '../../libs/aemComponents/Container';
import '../../libs/aemComponents/ExperienceFragment';
import { respGridUtil } from '@marriott/mi-headless-utils';
import {
  EditableHTLWrapper,
  CardLayered,
  CardVertical,
  AccordionContainerEnhanced,
  IconBlock,
  RichText,
} from '@marriott/mi-common-static-components';
import {
  HeaderTextCtaEditable,
  CardHorizontalFeature,
  CardCarouselContainer,
  SignatureCarousel,
  WysiwygTextEditable,
  ContactUsFooterEditable,
  QuoteEditable,
  LinkBanner,
  LogoBlockEditable,
  TopNavigationEditable,
  CinemographHeroEditable,
  OneUpHighlightEditable,
  BrandRibbonEditable,
  BreadcrumbEditable,
  ButtonBannerEditable,
  CarouselGallery,
  TabEditableComponent,
  DynamicPropertyCard,
  RoundUpEditable,
  MbopOffers,
  SearchFormEditable,
  HubHeroBasicEditable,
  LuxurySuitesEditable,
  SearchResultsComponentEditable,
} from '@marriott/mi-luxury-components';

export const AEM_REACT_MAPPING = {
  // luxury-spa
  [`mi-aem-luxury-spa/components/content/header-text-cta/v1/header-text-cta`]: HeaderTextCtaEditable,
  ['mi-aem-luxury-spa/components/content/cardcarouselcontainer/v1/cardcarouselcontainer']: CardCarouselContainer,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/signature-carousel/v1/signature-carousel`]:
    SignatureCarousel,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/wysiwyg/v1/wysiwyg`]: WysiwygTextEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/footer/v1/footer`]: ContactUsFooterEditable,
  ['mi-aem-luxury-spa/components/content/quote/v1/quote']: QuoteEditable,
  ['mi-aem-common-spa/components/content/tabcontainer']: TabEditableComponent,
  ['mi-aem-luxury-spa/components/content/cinemograph-hero/v1/cinemograph-hero']: CinemographHeroEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/one-up-highlight/v1/one-up-highlight`]:
    OneUpHighlightEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/brand-ribbon/v1/brand-ribbon`]: BrandRibbonEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/breadcrumb/v1/breadcrumb`]: BreadcrumbEditable,
  [`${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/button-banner/v1/button-banner`]: ButtonBannerEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/round-up/v1/round-up`]: RoundUpEditable,
  [`mi-aem-luxury-spa/components/content/baselinesearchform/v1/baselinesearchform`]: SearchFormEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hub-hero-basic/v1/hub-hero-basic`]: HubHeroBasicEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/suites-catalog/v1/suites-catalog`]: LuxurySuitesEditable,
  [`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/map-clusters/v1/map-clusters`]:
    SearchResultsComponentEditable,

  // common-spa
  [`mi-aem-common-spa/components/content/linkbanner`]: LinkBanner,
  [`mi-aem-common-spa/components/content/cardlayered`]: CardLayered,
  [`mi-aem-common-spa/components/content/cardvertical`]: CardVertical,
  [`mi-aem-common-spa/components/content/cardhorizontalfeature`]: CardHorizontalFeature,
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  [`mi-aem-common-spa/components/content/accordioncontainerenhanced`]: AccordionContainerEnhanced,
  [`mi-aem-common-spa/components/content/variablecolumncontainer`]: LogoBlockEditable,
  [`mi-aem-common-spa/components/content/iconblock`]: IconBlock,
  [`mi-aem-common-spa/components/content/carouselgallery`]: CarouselGallery,
  [`mi-aem-common-spa/components/content/richtext`]: RichText,

  //leisure-spa
  [`mi-aem-leisure-spa/components/cardCarouselResorts`]: DynamicPropertyCard,
  [`mi-aem-offers-spa/components/offers-cards`]: MbopOffers,
};

export const defineComponentMapping = (
  allowedComponents,
  isAuthorMode,
  pageProps,
  languageSelectorModal,
  featureFlagLogo
) => {
  // common-spa
  MapTo(`mi-aem-common-spa/components/content/cardlayered`)(
    props => <CardLayered {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'CardLayered',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/tabcontainer`)(
    props => (
      <TabEditableComponent
        {...props}
        isAuthorMode={isAuthorMode}
        allowedComponents={allowedComponents}
        componentPath="mi-luxury-components"
      />
    ),
    {
      emptyLabel: 'TabContainer',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-luxury-spa/components/content/baselinesearchform/v1/baselinesearchform`)(
    props => <SearchFormEditable {...props} isAuthorMode={isAuthorMode} isPositionedExternally={false} />,
    {
      emptyLabel: 'SearchForm',
      isEmpty: false,
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/suites-catalog/v1/suites-catalog`)(
    props => <LuxurySuitesEditable {...props} isAuthorMode={isAuthorMode} featureFlagLogo={featureFlagLogo} />,
    {
      emptyLabel: 'LuxurySuitesEditable',
      isEmpty: false,
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/map-clusters/v1/map-clusters`)(
    props => (
      <SearchResultsComponentEditable {...props} isAuthorMode={isAuthorMode} featureFlagLogo={featureFlagLogo} />
    ),
    {
      emptyLabel: 'SearchResultsComponentEditable',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/accordioncontainerenhanced`)(
    props => (
      <AccordionContainerEnhanced
        {...props}
        isAuthorMode={isAuthorMode}
        allowedComponents={allowedComponents}
        componentPath="mi-luxury-components"
      />
    ),
    {
      emptyLabel: 'AccordionContainerEnhanced',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/cardhorizontalfeature`)(
    props => <CardHorizontalFeature {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'CardHorizontalFeature',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/cardvertical`)(
    props => <CardVertical {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'CardVertical',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/variablecolumncontainer`)(
    props => <LogoBlockEditable {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />,
    {
      emptyLabel: 'Logo Block Editable',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/iconblock`)(props => <IconBlock {...props} />, {
    emptyLabel: 'Icon Block',
    isEmpty: false,
  });
  const ExperienceFragmentVariationConfig = {
    emptyLabel: 'Experience Fragment',

    isEmpty: function (props) {
      return !props || !props.configured;
    },
  };

  MapTo('mi-aem-common-spa/components/experiencefragment')(props => {
    return (
      <Container
        isInEditor
        {...props}
        isPage={false}
        model={respGridUtil(props?.model?.cqItems?.root?.[':items']?.responsivegrid)}
      />
    );
  }, ExperienceFragmentVariationConfig);

  // luxury-spa
  MapTo(`mi-aem-luxury-spa/components/content/header-text-cta/v1/header-text-cta`)(
    props => <HeaderTextCtaEditable {...props} isAuthorMode={isAuthorMode} featureFlagLogo={featureFlagLogo} />,
    {
      emptyLabel: 'LuxuryHeaderTextCta',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/linkbanner`)(
    props => <LinkBanner {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'LinkBanner',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/signature-carousel/v1/signature-carousel`)(
    props => <SignatureCarousel {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'SignatureCarousel',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-luxury-spa/components/content/cardcarouselcontainer/v1/cardcarouselcontainer`)(
    props => <CardCarouselContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />,
    {
      emptyLabel: 'LuxuryCarousel',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-luxury-spa/components/content/wysiwyg/v1/wysiwyg`)(
    props => <WysiwygTextEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'WysiwygText',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/footer/v1/footer`)(
    props => (
      <ContactUsFooterEditable {...props} isAuthorMode={isAuthorMode} languageSelectorModal={languageSelectorModal} />
    ),
    {
      emptyLabel: 'ContactUsFooter',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-luxury-spa/components/content/quote/v1/quote`)(
    props => <QuoteEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'LuxuryQuote',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-luxury-spa/components/content/top-navigation/v1/top-navigation`)(
    props => (
      <TopNavigationEditable
        {...props}
        isAuthorMode={isAuthorMode}
        languageSelectorModal={languageSelectorModal}
        featureFlagLogo={featureFlagLogo}
      />
    ),
    {
      emptyLabel: 'TopNavigation',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-luxury-spa/components/content/one-up-highlight/v1/one-up-highlight`)(
    props => <OneUpHighlightEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'LuxuryOneUpHighlight',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-luxury-spa/components/content/cinemograph-hero/v1/cinemograph-hero`)(
    props => <CinemographHeroEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'CinemographHero',
      isEmpty: false,
    }
  );
  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/breadcrumb/v1/breadcrumb`)(
    props => <BreadcrumbEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'LuxuryBreadcrumb',
      isEmpty: false,
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/brand-ribbon/v1/brand-ribbon`)(
    props => <BrandRibbonEditable {...props} isAuthorMode={isAuthorMode} featureFlagLogo={featureFlagLogo} />,
    {
      emptyLabel: 'BrandRibbon',
      isEmpty: false,
    }
  );

  MapTo(`${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/button-banner/v1/button-banner`)(
    props => <ButtonBannerEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'ButtonBanner',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-common-spa/components/content/carouselgallery`)(
    props => <CarouselGallery {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'CarouselGalleryTriptych',
      isEmpty: false,
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/round-up/v1/round-up`)(
    props => <RoundUpEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'LuxuryRoundUp',
      isEmpty: false,
    }
  );

  MapTo(`${process.env.NEXT_PUBLIC_AEM_SITE}/components/content/hub-hero-basic/v1/hub-hero-basic`)(
    props => <HubHeroBasicEditable {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'LuxuryHubHeroBasic',
      isEmpty: false,
    }
  );

  //leisure-spa

  MapTo(`mi-aem-leisure-spa/components/cardCarouselResorts`)(props => (
    <div className={`m-container-fullbleed ${props?.model?.styleclass ?? ''}`}>
      <DynamicPropertyCard
        {...props}
        isAuthorMode={isAuthorMode}
        acceptLanguage={pageProps?.headersData['accept-language']}
        requestId={pageProps?.requestId}
        subDirectoryContextPath={pageProps?.model?.subDirectoryContextPath}
        isDTT={pageProps?.isDTT}
      />
    </div>
  ));

  MapTo(`mi-aem-offers-spa/components/offers-cards`)(props => (
    <div className={`m-container-fullbleed ${props?.model?.styleclass ?? ''}`}>
      <MbopOffers
        {...props}
        isAuthorMode={isAuthorMode}
        acceptLanguage={pageProps?.headersData['accept-language']}
        requestId={pageProps?.requestId}
        cookie={pageProps?.headersData['cookie']}
      />
    </div>
  ));

  MapTo(`mi-aem-common-spa/components/content/richtext`)(props => <RichText {...props} isAuthorMode={isAuthorMode} />, {
    emptyLabel: 'RichText',
    isEmpty: false,
  });

  const existingMappings = Object.keys(AEM_REACT_MAPPING);
  if (allowedComponents) {
    allowedComponents.forEach(mapping => {
      const baseModelPath = '/jcr:content/root/responsivegrid/[:items]/responsivegrid';
      const componentPath = mapping.path.split(baseModelPath)[1];

      if (existingMappings.indexOf(componentPath) === -1) {
        MapTo(componentPath)(EditableHTLWrapper, {
          emptyLabel: mapping.title,
          isEmpty: false,
        });
      } else {
        console.log('mapping exists', componentPath);
      }
    });
  }
};
